import { api } from "..";

export async function updateFullMatch({
  id,
  status,
  periods,
  events,
}: {
  id: number;
  status: string;
  periods: any[];
  events: any[];
}) {
  const res = await api.client.put("/matches", {
    id: id,
    status,
    periods,
    events,
  });
  return res.data;
}
